import {
  InstrumentGroupDetailDto,
  InstrumentGroupEditDto
} from './instrumentgroup';

export const mapInstrumentGroupDetailToEdit = (
  dto: InstrumentGroupDetailDto
): InstrumentGroupEditDto => ({
  id: dto.id,
  name: dto.name,
  corrected: dto.corrected,
  description: dto.description
});
